import React, { forwardRef } from 'react';

const InputSearch = forwardRef(({ value, onChange, placeholder, name, id }, ref) => {
  return (
    <div className="relative w-full">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <span className="material-icons text-blue-600">search</span>
      </div>
      <input
        id={id || name}
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        ref={ref}  // Aquí pasamos el ref
        className="block w-full pl-10 pr-3 py-2 text-sm text-black bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 shadow-lg"
      />
    </div>
  );
});

export default InputSearch;  // Asegúrate de exportarlo correctamente
